import angular from 'angular';
import Backend from './backend.service';

let serviceModule = angular.module('app.services.backend', [])
.service('Backend', Backend);

export default serviceModule;



/** WEBPACK FOOTER **
 ** ./client/app/services/backend/index.js
 **/